module.exports = __webpack_public_path__ + "static/media/STANDARD_START_FAST.229cd701.mp3";